import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MaterialModule as MaterialModule } from '../material/material.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AppRoutingModule } from '../app-routing.module';
import { datadogRum } from '@datadog/browser-rum';

export class GenericErrorHandler implements ErrorHandler {
  handleError(error: any): void {
      datadogRum.addError(error);
      console.error(error);
  }
}

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AppRoutingModule
  ],
  providers:  [
    { provide: ErrorHandler, useClass: GenericErrorHandler },
  ],
  exports: [
    HeaderComponent,
    SidebarComponent
  ]

})
export class LayoutsModule { }
